"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function dateParse(date) {
    if (date.length === 10) {
        return new Date(date + ' 00:00:00');
    }
    else {
        return new Date(date);
    }
}
exports.default = dateParse;
//# sourceMappingURL=dateParse.js.map